var path = '/src/breakFrame/breakFrame.html';
var html = "<div class=\"text-center\">\n    <a class=\"btn btn-primary btn-raised\" ui-sref=\"eventix.shop.tickets({ shopId: vm.shopId })\" target=\"_blank\" translate>common.notice.breakiFrame</a>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;